export enum ProductGroup {
    ANCILLARY_OIL = 'ANCILLARY_OIL',
    BASE_OIL = 'BASE_OIL',
    BLEND_ON_BOARD_ADDITIVES = 'BLEND_ON_BOARD_ADDITIVES',
    CYLINDER_OIL = 'CYLINDER_OIL',
    ENGINE_OIL_4_STROKE = 'ENGINE_OIL_4_STROKE',
    GREASE = 'GREASE',
    SAMPLE_ANALYSIS = 'SAMPLE_ANALYSIS',
    TEST_KIT = 'TEST_KIT',
    // The backend enum value contains this typo.
    SYSTEM_OIL_2_STROKE = 'SYSMTEM_OIL_2_STROKE',
}
